import actions from '../actionTypes'

const nonexistentState = null

const initial = nonexistentState

export default function (state = initial, { type, payload }) {
  switch (type) {
    case actions.industrySubDetailOptionsSource.SET: {
      return payload
    }
    case actions.industrySubDetailOptionsSource.DELETE: {
      return nonexistentState
    }
    default:
      return state
  }
}
